function calculateMotor() {
    // Retrieve user inputs
    const application = document.getElementById('application').value;
    const torqueLevel = document.getElementById('torqueLevel').value;
    const voltage = document.getElementById('voltage').value;
    const phase = document.getElementById('phase').value;
    const environment = document.getElementById('environment').value;
    const dutyCycle = document.getElementById('dutyCycle').value;
    const spaceConstraints = document.getElementById('spaceConstraints').value;

    const resultElement = document.getElementById('result');
    const resultContainer = document.getElementById('motorDisplay');

    // Clear any previous classes or messages
    resultElement.classList.remove('error', 'visible', 'success');
    resultElement.innerText = ""; // Clear previous text

    // Validate inputs
    const missingFields = [];
    if (!application) missingFields.push("Application");
    if (!torqueLevel) missingFields.push("Torque Level");
    if (!voltage) missingFields.push("Voltage");
    if (!phase) missingFields.push("Phase");
    if (!environment) missingFields.push("Environment");
    if (!dutyCycle) missingFields.push("Duty Cycle");
    if (!spaceConstraints) missingFields.push("Space Constraints");

    if (missingFields.length > 0) {
        resultElement.classList.add('error'); // Add error class
        resultElement.innerText = `Please complete the following fields: ${missingFields.join(", ")}`;
        resultContainer.classList.add('visible');
        return;
    }

    // Define torque values based on the load type
    let torque = 0;
    if (torqueLevel === "light") {
        torque = 10; // ft-lb for light loads
    } else if (torqueLevel === "medium") {
        torque = 30; // ft-lb for medium loads
    } else if (torqueLevel === "heavy") {
        torque = 50; // ft-lb for heavy loads
    }

    // Define RPM based on the application type
    const rpmMappings = {
        fan: 1750,
        pump: 1450,
        conveyor: 1000,
        crusher: 850,
        woodshop: 3600,
        hvac: 1725,
        compressor: 1200,
        elevator: 900,
        mixer: 600,
        grinder: 3000,
        lathe: 2000,
    };
    const rpm = rpmMappings[application] || 0; // Default to 0 if not found

    // Calculate HP
    const hp = (torque * rpm) / 5252;

    // Build recommendation message
    let recommendation = `Based on your inputs:
    \n- Application: ${application}
    \n- Torque Level: ${torqueLevel}
    \n- Voltage: ${voltage}V
    \n- Phase: ${phase}
    \n- Environment: ${environment}
    \n- Duty Cycle: ${dutyCycle}
    \n- Space Constraints: ${spaceConstraints}
    \n\nRecommended Motor HP: ${hp.toFixed(2)} HP`;

    // Environmental considerations
    const environmentRecommendations = {
        hazardous: "Use a motor with explosion-proof certification for hazardous environments.",
        wet: "Use a motor with a sealed enclosure (IP55 or higher) for wet or humid environments.",
        dusty: "Use a motor designed for dusty environments with proper ventilation and filters.",
    };

    if (environmentRecommendations[environment]) {
        recommendation += `\n- Note: ${environmentRecommendations[environment]}`;
    }

    // Duty cycle recommendations
    if (dutyCycle === "intermittent") {
        recommendation += `\n- Note: An intermittent-duty motor is suitable for this application, as the motor won't run continuously.`;
    } else if (dutyCycle === "continuous") {
        recommendation += `\n- Note: A continuous-duty motor with high efficiency is recommended for 24/7 operation.`;
    }

    // Space constraints considerations
    if (spaceConstraints === "compact") {
        recommendation += `\n- Note: Use a compact motor design, such as a TEFC (Totally Enclosed Fan-Cooled) motor, to fit limited spaces.`;
    }

    // Voltage and phase recommendations
    if (hp > 10 && phase === "single") {
        recommendation += `\n- Warning: Single-phase motors are not recommended for applications requiring more than 10 HP. Consider a three-phase motor.`;
    }
    if (voltage === "custom") {
        recommendation += `\n- Note: Consult a specialist to ensure compatibility with your custom voltage requirements.`;
    }

    // Display result with delay
    setTimeout(() => {
        resultElement.innerText = recommendation;
        resultElement.classList.add('success', 'visible'); // Add success and visible classes
        resultContainer.classList.add('visible'); // Show the result container
    }, 500); // 500ms delay for smoother experience
}


